import { Spin, Tabs } from "antd";
const { TabPane } = Tabs;
import * as React from "react";
import { BcheckStatusIcon } from "src/services/interfaces/Compliance/BcheckStatusIcon";
import { ViewTradeBCheckModal } from "../BcheckView/ViewTradeBCheckModal";
import { IBCheckModal } from "src/services/interfaces/Compliance/IBCheckModal";
import * as _ from "lodash";

interface IAnalysisModalProps {
    analysis: IBCheckModal[];
    isLoading: boolean;
}

export const AnalysisModal: React.FC<IAnalysisModalProps> = ({
    analysis,
    isLoading,
}) => {

    const hasBCheck = !_.isEmpty(analysis);


    return (
        <Spin spinning={isLoading}>
            <div className="analysis-modal wrap">
                {hasBCheck && analysis.map((item, index) => (
                    <div key={index} className="span-wrap card">
                        <div className="wrap">
                            <div className="span-wrap-10">
                                <span className="label">{item.responsible}</span>
                            </div>
                            {item.compliance && (
                                <div className="span-wrap">
                                    <span className="label small">Compliance</span>
                                    <span className="value">
                                        <BcheckStatusIcon status={item.compliance.status} />
                                    </span>
                                </div>
                            )}
                            {item.credit && (
                                <>
                                    <div className="span-wrap">
                                        <span className="label small">Crédito</span>
                                        <span className="value">
                                            <BcheckStatusIcon status={item.credit.status} />
                                        </span>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                ))
                }
            </div>

            <Tabs defaultActiveKey={hasBCheck ? 'BCheck' : ''}>
                <TabPane disabled={!hasBCheck} tab="BCheck" key='BCheck'>
                    {hasBCheck && <ViewTradeBCheckModal isLoading={isLoading} compliances={analysis} showCompliance showCredit />}
                </TabPane>
            </Tabs>
        </Spin>
    )
}


// WEBPACK FOOTER //
// ./src/components/common/AnalisysModal/AnalysisModal.tsx